define('views/modules/setting/business/modals/payment-update-method-modal',[
    // Libs
    'underscore',
    //services
    'services/i18n',
    // views
    'views/modules/setting/business/modals/payment-add-method-modal',
    'views/modules/setting/business/payment/payment-update-method-notice',
    // templates
    'text!templates/modules/setting/business/modals/payment-update-method-modal.html',
], function(
    // Libs
    _,
    //services
    i18n,
    // views
    VPaymentAddMethod,
    VPaymentUpdateMethodNotice,
    //templates
    TPaymentUpdateMethodModal
) {
    var VPaymentUpdateMethodModal = VPaymentAddMethod.extend({
        template: TPaymentUpdateMethodModal,

        regions: function() {
            var region = VPaymentUpdateMethodModal.__super__.regions;

            return _.extend(region, { paymentUpdateMethodNotice: '.payment-update-method-notice' });
        },

        modal: function() {
            var modal = VPaymentUpdateMethodModal.__super__.modal.apply(this);

            return _.extend(modal, {
                title: i18n.t("payment:edit_payment_method"),
            });
        },

        initialize: function(opt) {
            VPaymentUpdateMethodModal.__super__.initialize.apply(this, [opt]);

            this.view = _.extend(this.view, {
                paymentUpdateMethodNotice: new VPaymentUpdateMethodNotice({}),
            });
        },

        generateRegions: function() {
            VPaymentUpdateMethodModal.__super__.generateRegions.apply(this);

            this.assign(this.view.paymentUpdateMethodNotice, this.zone.$paymentUpdateMethodNotice);
        },

        updateOptions: function(options) {
            this.options.pendingPlanModel = options.pendingPlanModel;

            VPaymentUpdateMethodModal.__super__.updateOptions.apply(this, [options]);
        },

        getPaymentMethod: function() {
            return 'upgrade';
        },

        getPaypalPostData: function() {
            return { membership: this.options.pendingPlanModel.getName() };
        },

    });

    return VPaymentUpdateMethodModal;
});

